import React from 'react';
import { ClassNameMap } from '@mui/styles';
import { GroupType } from 'graphql/types';
import { DepartmentsSelect } from './groupSelectTypes/DepartmentsSelect';
import { LocationsSelect } from './groupSelectTypes/LocationsSelect';
import { EmployeeTypesSelect } from './groupSelectTypes/EmployeeTypesSelect';
import { DivisionsSelect } from './groupSelectTypes/DivisionsSelect';
import { CostCentersSelect } from './groupSelectTypes/CostCentersSelect';
import { ServiceCentersSelect } from './groupSelectTypes/ServiceCentersSelect';

type GroupSelectClassificationProp = {
  groupType: string;
  rowID: string;
  defaultValues: any[];
  classes?: ClassNameMap;
};

export const GroupSelectClassification: React.FC<GroupSelectClassificationProp> = (
  props: GroupSelectClassificationProp
) => {
  const { groupType } = props;
  switch (groupType) {
    case GroupType.Department: {
      return <DepartmentsSelect {...props} />;
    }
    case GroupType.Location: {
      return <LocationsSelect {...props} />;
    }
    case GroupType.EmployeeType: {
      return <EmployeeTypesSelect {...props} />;
    }
    case GroupType.Division: {
      return <DivisionsSelect {...props} />;
    }
    case GroupType.CostCenter: {
      return <CostCentersSelect {...props} />;
    }
    case GroupType.ServiceCenter: {
      return <ServiceCentersSelect {...props} />;
    }
    default: {
      return <></>;
    }
  }
};
